/* src/app/admin-dashboard/membership-v2/dialogs/dialog-shared.css */
.v2-dialog {
  display: flex;
  flex-direction: column;
  min-width: 380px;
  padding-top: 6px;
}
.v2-dialog .full {
  width: 100%;
}
.v2-dialog-checks {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 4px 0 8px;
}
.v2-dialog-block {
  margin: 6px 0 10px;
  padding: 10px 12px;
  background: #fafafa;
  border: 1px solid #eee;
  border-radius: 6px;
}
.v2-dialog-block > mat-checkbox {
  display: block;
  margin-bottom: 8px;
}
.v2-dialog-row {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}
.v2-dialog-row mat-form-field {
  width: 120px;
}
.v2-dialog-systems {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
}
.v2-dialog-label {
  font-size: 13px;
  font-weight: 600;
  color: #555;
  margin-bottom: 6px;
}
.v2-dialog-hint {
  font-size: 12px;
  color: #888;
  margin: 4px 0 0;
}
.import-intro a {
  margin-left: 4px;
}
.import-file {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 4px 0 8px;
}
.import-file-name {
  font-size: 13px;
  color: #555;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.import-error {
  color: #c62828;
  font-size: 13px;
  margin: 0 0 8px;
}
.import-summary {
  font-size: 13px;
  font-weight: 600;
  margin: 6px 0;
}
.import-table-wrap {
  max-height: 320px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 6px;
}
.import-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.import-table th {
  position: sticky;
  top: 0;
  background: #fafafa;
  text-align: left;
  font-weight: 600;
}
.import-table th,
.import-table td {
  padding: 5px 8px;
  border-bottom: 1px solid #f0f0f0;
}
.import-table tr.is-skip td,
.import-table tr.is-failed td:last-child {
  color: #c62828;
}
.import-table tr.is-added td:last-child {
  color: #2e7d32;
}
.import-table tr.is-skip td {
  opacity: .75;
}
/*# sourceMappingURL=dialog-shared.css.map */
